// ErrorDisplay.tsx
import React from 'react';
import { Box, Typography, Button } from '@mui/material';

// ** REPLACE WITH YOUR ACTUAL IMAGE PATHS **
const UNABLE_TO_DISPLAY_DATA_ICON = '/images/no-val-result.svg'; 

interface ErrorDisplayProps {
  title: string;
  message: string;
  onRefresh: () => void;
}

const ErrorDisplay: React.FC<ErrorDisplayProps> = ({ title, message, onRefresh }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        height: '100%',
        p: 3,
        marginRight:5,
        marginBottom:20,
        marginTop:-8
      }}
    >
      <img
        src={UNABLE_TO_DISPLAY_DATA_ICON}
        alt="Unable to display data"
        style={{ width: '120px', height: '120px', marginBottom: '24px' }}
      />
      <Typography
        variant="h6"
        sx={{ fontWeight: 600, color: '#333333', mb: 1, fontSize:'16px',fontFamily:'Inter',lineHeight:'20px' }}
      >
        {title}
      </Typography>
      <Typography
        variant="body2"
        sx={{ fontWeight: 400, color: '#333333', fontSize:'12px',fontFamily:'Inter', mb: 1,lineHeight:'20px' }}
      >
        {message}
      </Typography>
      <Button
        variant="text"
        onClick={onRefresh}
        sx={{
            textTransform: 'none',
            color: '#0064FF',
            fontWeight: 500,
            fontFamily:'Inter',
            lineHeight:'21px',
            fontSize:'14px'
        }}
        >
        Refresh Page
        </Button>
    </Box>
  );
};

export default ErrorDisplay;